export default __webpack_public_path__ + "static/media/audio-off.7c81cdbc.svg";